var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 142,
    viewBox: "0 0 172 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0498 60.3525C26.868 60.5489 33.9152 57.5065 37.4393 52.5997V41.8049H0V45.9264C0 53.6792 8.58912 60.0578 19.0498 60.3525Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.515 89.0073H136.323V111.284H90.515V89.0073Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.023 60.3525C115.511 60.3525 122.338 57.3105 125.642 52.5997V41.8049H90.4047V52.5997C93.7084 57.31 100.535 60.3525 108.023 60.3525Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8441 60.2544C36.1179 65.5536 26.9787 68.3996 18.8299 68.2032C17.1783 68.2032 15.6364 68.0067 14.2052 67.8107V138.271C14.2052 140.332 16.0772 142 18.3896 142H26.9782V88.5168C26.9782 84.4931 30.612 81.1569 35.2367 81.1569H62.8756C67.3906 81.1569 71.1341 84.3953 71.1341 88.5168V142H153.721C156.033 142 157.905 140.332 157.905 138.271V67.8107C156.364 68.0072 154.822 68.2032 153.17 68.2032C144.141 68.3996 135.662 65.4554 130.156 60.2544C124.76 65.1612 116.722 68.2032 108.133 68.2032C99.5435 68.2032 91.3952 65.1612 86.1098 60.2544C80.7141 65.1612 72.6755 68.2032 64.0864 68.2032C55.2778 68.2032 47.2397 65.2594 41.8441 60.2544ZM81.706 89.3021C81.706 84.7877 85.7801 81.1569 90.8456 81.1569H135.993C141.058 81.1569 145.133 84.7877 145.133 89.3021V110.99C145.133 115.504 141.058 119.135 135.993 119.135H90.8456C85.7801 119.135 81.706 115.504 81.706 110.99V89.3021Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.758 0H90.5149L90.4047 34.0527H124.21L112.758 0Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9925 0H32.154C28.0799 0 24.446 1.66832 22.7944 4.2197L3.30383 34.0527H38.6507L49.9925 0Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5958 34.0527L81.706 0H59.1321L47.7903 34.0527H81.5958Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5958 52.5997V41.8049H46.2489V52.5997C49.6623 57.31 56.3794 60.3525 63.8675 60.3525C71.3555 60.3525 78.2921 57.4082 81.5958 52.5997Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.561 52.5997C138.085 57.5065 145.132 60.5485 152.95 60.3525C163.411 60.0583 172 53.6792 172 46.0251V41.9036H134.561L134.561 52.5997Z",
    fill: "current"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6774 89.0073H62.3254V141.902H35.6774V89.0073Z",
    fill: "current"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.697 34.0527L149.206 4.2197C147.555 1.66832 143.811 0 139.847 0H121.898L133.35 34.0527H168.697Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/commerce.b664413965d099d68ae35465c56017ab.svg";
export { ForwardRef as ReactComponent };